<template>
  <footer>
    <div>
      <b-navbar
        id="footer1"
        class="navbar"
      >
        <b-navbar-nav>
          <!-- Left aligned -->
          <!-- <b-nav-text class="margin-top"></b-nav-text> -->
          <b-navbar-brand href="#">
            <img
              class="navbar-logo"
              src="@/assets/CATS_Logo.png"
            />
          </b-navbar-brand>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav class="footer-padding">
            <locale-switcher />
            <b-nav-item
              href="https://molit.eu/impressum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('impressum') }}
            </b-nav-item>
            <b-nav-item
              href="https://molit.eu/datenschutzerklaerung/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <!--
                Mobile: the short label saves horizontal space. The full
                label is kept at the desktop breakpoint (unchanged).
              -->
              {{
                isMobileViewport
                  ? $t('privacyStatementShort')
                  : $t('privacyStatement')
              }}
            </b-nav-item>
            <b-nav-item
              v-if="!hideCookiePreferencesBtn"
              href="#"
              @click="manageTrackingConsentClicked"
            >
              <!--
                Mobile: icon instead of the long link text to save
                horizontal space. The tooltip and aria-label keep the
                original text accessible. Desktop: text, unchanged.
              -->
              <BTooltip
                v-if="isMobileViewport"
                :title="$t('manageTrackingConsent')"
                placement="top"
                class="tooltip-green ds500"
              >
                <template #target
                  ><CookieOutline
                    class="cookie-consent-icon"
                    :title="$t('manageTrackingConsent')"
                /></template>
              </BTooltip>
              <span
                v-else
                class="cookie-consent-text"
              >
                {{ $t('manageTrackingConsent') }}
              </span>
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-navbar>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LocaleSwitcher from '@/components/General/LocaleSwitcher.vue';
import CookieOutline from 'vue-material-design-icons/CookieOutline.vue';
import { useIsMobileViewport } from '@/helperScripts/ui/useIsMobileViewport';

export default defineComponent({
  name: 'SiteFooter',

  components: {
    LocaleSwitcher,
    CookieOutline,
  },

  props: { hideCookiePreferencesBtn: { type: Boolean, default: false } },

  emits: ['manageTrackingConsentClicked'],

  data() {
    return {
      //Below the mobile breakpoint (see useIsMobileViewport, the same
      //breakpoint as the top bar and the study list cards) the cookie
      //consent link is rendered as an icon to save horizontal space
      isMobileViewport: useIsMobileViewport(),
    };
  },

  methods: {
    manageTrackingConsentClicked() {
      this.$emit('manageTrackingConsentClicked');
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.navbar-logo {
  max-height: 2rem;
}
.footer-padding {
  padding-left: 260px;
}
#footer1 {
  padding: 0px 2rem;
}
// A b-navbar without a `toggleable` breakpoint is rendered with the
// `navbar-expand` class, which switches .navbar-nav to a horizontal
// (flex-direction: row) layout. Without an explicit wrap allowance, the
// footer's link row (locale switcher + legal links) has a min-content
// width that exceeds phone viewports. Since the single-column grid of
// #app (App.vue) cannot shrink below the min-content of its items, the
// whole page is then stretched horizontally. Wrapping keeps the
// single-line layout at wide viewports (where everything fits) and lets
// the links flow to a second line at narrow viewports.
#footer1 .navbar-nav {
  flex-wrap: wrap;
}
// App.vue pins the footer to a fixed height (class .main-footer), which
// would clip the wrapped second line of links at narrow viewports. Like
// in Fallback.vue, let the footer grow with its content and keep the
// standard height only as a minimum.
//
// The background lives on the <footer> element itself (not on the inner
// navbar) so that it covers the footer's full height, also when the link
// row wraps to a second line at narrow viewports. Without this, the strip
// below the navbar appeared as an empty gap at the bottom of the page.
footer {
  background-color: $vitu-background;
  min-height: $footer-height;
  height: auto;
}
//Mobile cookie-consent icon: inherits the nav link color and is centered
//vertically within the link like the text version
.cookie-consent-icon {
  vertical-align: middle;
}
@media only screen and (max-width: 900px) {
  .footer-padding {
    padding: 0px;
  }
  .navbar-logo {
    display: none;
  }
  #footer1 {
    margin: 0px;
  }
}
</style>
